/**
 * 発注 積替運搬
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'
import * as types from '../../../../mutation-types/driver-types'


const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/requests/pickups`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
    },
  }
}
const manifest_request_pickup = {

  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
    * 詳細取得
    * @param commit
    * @param id
    * @return {Promise<unknown>}
    */
    show ({ commit }, { id, page }) {
      const params = { page: page }
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
        let content = data.content
        commit(types.DRIVER_MANIFEST_REQUEST_PICKUP_PAGINATION, { content })
        resolve(content)
        })
      })
    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
        let content = data.content
        commit(types.DRIVER_MANIFEST_REQUEST_PICKUP_PAGINATION, { content })
        resolve(content)
        })
      })
    }
  },
  mutations: {
    [types.DRIVER_MANIFEST_REQUEST_PICKUP_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.DRIVER_MANIFEST_REQUEST_PICKUP_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
  },
}

export default manifest_request_pickup
